module.exports = __webpack_public_path__ + "static/img/live_wechat01.a423461.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/live_wechat01.png
// module id = JyCa
// module chunks = 1